import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Role, Roles } from '../enums/enums';
import { UserService } from '@planetact/services/user.service';
import { ROLE_KEY } from '../configToken';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: MsalService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.authService.instance.getAllAccounts().length > 0) {
      return this.userService.getUserRole().pipe(
        map((userRole) => {
          localStorage.setItem(ROLE_KEY, JSON.stringify(userRole));
          return Roles.includes(userRole.roleName);
        })
      );
    } else {
      return false;
    }
  }
}
